const en = require("./en.json");
const ar = require("./ar.json");
const bg = require("./bg.json");
const cs = require("./cs.json");
const da = require("./da.json");
const de = require("./de.json");
const el = require("./el.json");
const en_Gb = require("./en-GB.json");
const es_MX = require("./es-MX.json");
const es = require("./es.json");
const et = require("./et.json");
const fa = require("./fa.json");
const fi = require("./fi.json");
const fr_CA = require("./fr-CA.json");
const fr = require("./fr.json");
const he = require("./he.json");
const hi = require("./hi.json");
const hr = require("./hr.json");
const hu = require("./hu.json");
const hy = require("./hy.json");
const id = require("./id.json");
const ja = require("./ja.json");
const ko = require("./ko.json");
const it = require("./it.json");
const lt = require("./lt.json");
const lv = require("./lv.json");
const ms = require("./ms.json");
const nl = require("./nl.json");
const no = require("./no.json");
const pl = require("./pl.json");
const pt_BR = require("./pt-BR.json");
const pt = require("./pt.json");
const ro = require("./ro.json");
const ru = require("./ru.json");
const sk = require("./sk.json");
const sl = require("./sl.json");
const sr = require("./sr.json");
const sv = require("./sv.json");
const th = require("./th.json");
const tr = require("./tr.json");
const uk = require("./uk.json");
const vi = require("./vi.json");
const zh_CN = require("./zh-CN.json");
const zh_TW = require("./zh-TW.json");

const languages: { [locale: string]: any } = {
    en: en,
    ar: ar,
    bg: bg,
    cs: cs,
    da: da,
    de: de,
    el: el,
    "en-GB": en_Gb,
    "es-MX": es_MX,
    es: es,
    et: et,
    fa: fa,
    fi: fi,
    "fr-CA": fr_CA,
    fr: fr,
    he: he,
    hi: hi,
    hr: hr,
    hu: hu,
    hy: hy,
    id: id,
    ja: ja,
    ko: ko,
    it: it,
    lt: lt,
    lv: lv,
    ms: ms,
    nl: nl,
    no: no,
    pl: pl,
    "pt-BR": pt_BR,
    pt: pt,
    ro: ro,
    ru: ru,
    sk: sk,
    sl: sl,
    sr: sr,
    sv: sv,
    th: th,
    tr: tr,
    uk: uk,
    vi: vi,
    "zh-CN": zh_CN,
    "zh-TW": zh_TW
};

export { languages };
